<template>
  <div class="pt-6 flex flex-wrap">
      <div class="flex-wrap items-center w-3/4 border-right p-2">
        <div class="border-bottom w-full pb-4">
          <div class="my-2 pb-4 text-lg font-bold" for="qr-content">Content</div>
          <div class="flex w-full my-2" >
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-content-website" class="visible" type="radio"  value="website" v-model="options.qr_content.type">
              <label for="qr-content-website">Web Page</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-content-email" class="visible" type="radio"  value="email" v-model="options.qr_content.type">
              <label for="qr-content-email">Email</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-content-phone" class="visible" type="radio"  value="phone" v-model="options.qr_content.type">
              <label for="qr-content-phone">Phone</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-content-sms" class="visible" type="radio"  value="sms" v-model="options.qr_content.type">
              <label for="qr-content-sms">SMS</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-content-location" class="visible" type="radio"  value="location" v-model="options.qr_content.type">
              <label for="qr-content-location">Location</label>
            </div>
          </div>
          <div class="w-3/4 my-2" v-show="options.qr_content.type==='website'">
            <div class="w-full">
              <div class="w-full py-2 mt-4 mr-2">Your URL:</div>
              <input type="text" class="w-full block border mt-2 mb-6 p-2" v-model="options.qr_content.website" placeholder="http://example.com">
            </div>
            <div class="flex w-full w-1/2">
              <div class="w-1/2 mr-2">
                <div class="w-full py-2 mt-4">URL UTM_source (optional):</div>
                <input type="text" class="w-full block border mt-2 mb-6 p-2" v-model="options.qr_content.UTM_source">
              </div>
              <div class="w-1/2">
                <div class="w-full py-2 mt-4">URL UTM_campaign (optional):</div>
                <input type="text" class="w-full block border mt-2 mb-6 p-2" v-model="options.qr_content.UTM_campaign">
              </div>
            </div>
            <div class="flex w-full w-1/2">
              <div class="w-1/2 mr-2">
                <div class="w-full py-2 mt-4">URL UTM_medium (optional):</div>
                <input type="text" class="block w-full border mt-2 mb-6 p-2" v-model="options.qr_content.UTM_medium">
              </div>
              <div class="w-1/2">
                <div class="w-full py-2 mt-4">URL UTM_content (optional):</div>
                <input type="text" class="block w-full border mt-2 mb-6 p-2" v-model="options.qr_content.UTM_content">
              </div>
            </div>
            <div class="flex w-full w-1/2">
              <div class="w-1/2 mr-2">
                <div class="w-full py-2 mt-4">URL UTM_term (optional):</div>
                <input type="text" class="block w-full border mt-2 mb-6 p-2" v-model="options.qr_content.UTM_term">
              </div>
            </div>
          </div>
          <div class="w-3/4 my-2" v-show="options.qr_content.type==='email'">
            <div class="w-full py-2 mt-4">Your Email:</div>
            <input type="email" class="block w-full border mt-2 p-2" v-model="options.qr_content.email" placeholder="name@mail.com">
            <div class="w-full py-2 mt-4">Subject:</div>
            <input type="text" class="block w-full border mt-2 p-2" v-model="options.qr_content.emailSubject" placeholder="Subject">
            <div class="w-full py-2 mt-4">Message (If required):</div>
            <textarea class="block w-full border mt-2 p-2" v-model="options.qr_content.emailMsg" placeholder="Type your message here..."></textarea>
          </div>
          <div class="w-3/4  my-2" v-show="options.qr_content.type==='phone'">
            <div class="w-full py-2 mt-4">Your Phone Number:</div>
            <input type="text" class="block w-full border mt-2 mb-6 p-2" v-model="options.qr_content.phone" placeholder="7123 456 789">
          </div>
          <div class="w-3/4  my-2" v-show="options.qr_content.type==='sms'">
            <div class="w-full py-2 mt-4">Your Phone Number:</div>
            <input type="text" class="block w-full border mt-2 mb-6 p-2" v-model="options.qr_content.phone" placeholder="7123 456 789">
            <div class="w-full py-2 mt-4">Message (If required):</div>
            <textarea class="block w-full border mt-2 p-2" v-model="options.qr_content.smsMsg" placeholder="Type your message here..."></textarea>
          </div>
          <div class="w-3/4  my-2" v-show="options.qr_content.type==='location'">
            <div class="w-full py-2 mt-4">Add Your Address:</div>
            <div class="w-full border flex items-center border-grey-dark rounded p-2">
              <input class="w-full text-sm" placeholder="Postcode, Town, Village..." v-model="options.qr_content.address" @blur="setPlace" />
              <icon name="magnify_glass" :center="false" class="text-grey-dark w-8 h-8" @click="setPlace" />
            </div>
            <GmapMap
              :center="coords"
              :zoom="15"
              :options="{disableDefaultUI: true, zoomControl: true, country: 'GB'}"
              map-type-id="roadmap"
              class="w-full h-64"
            >
              <GmapMarker
                :position="coords"
                :clickable="true"
                :draggable="true"
                ref="addressMarker"
                @dragend="setCoord"
              />
            </GmapMap>
            <div class="w-full py-2 flex" >
              <div class="block w-1/2 mt-2">Lat:</div>
              <div class="block w-1/2 mt-2">Lon:</div>
            </div>
            <div class="w-full flex mb-5" >
              <input type="text" class="block w-1/2 border mb-6 p-2" :value="options.qr_content.lat" disabled>
              <input type="text" class="block w-1/2 border mb-6 p-2" :value="options.qr_content.lon" disabled>
            </div>
          </div>
        </div>
        <div class="border-bottom w-full pb-4 mt-6">
          <div class="my-2 pb-4 text-lg font-bold" for="qr-content">Colours</div>
          <div class="flex w-full my-2" >
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-colour-single" class="visible" type="radio" value="single" v-model="options.qr_colour.type">
              <label for="qr-colour-single">Single Colour</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-colour-gradient" class="visible" type="radio"  value="gradient" v-model="options.qr_colour.type">
              <label for="qr-colour-gradient">Colour Gradient</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-inverse-gradient" class="visible" type="radio"  value="inverse-gradient" v-model="options.qr_colour.type">
              <label for="qr-inverse-gradient">Inverse Gradient</label>
            </div>
          </div>
          <div class="flex w-full my-2">
            <div class="w-1/3 flex flex-col mr-8">
              <div class="w-full py-2 mt-4">Main Colour:</div>
              <colour-picker-input v-model="options.qr_colour.colour1"  :disabled="system.id.toString() === '3'" />
            </div>
            <div class="w-1/3 flex flex-col">
              <div class="w-full py-2 mt-4">Secondary Colour:</div>
              <colour-picker-input v-model="options.qr_colour.colour2"  :disabled="system.id.toString() === '3'" />
            </div>
          </div>
          <div class="flex w-full my-2">
            <div class="w-1/3 flex flex-col mr-8">
              <div class="w-full py-2 mt-4">Background Colour:</div>
              <colour-picker-input v-model="options.qr_colour.colourBg"  :disabled="system.id.toString() === '3'" />
            </div>
          </div>
        </div>
        <div class="border-bottom w-full pb-4 mt-6">
          <div class="my-2 pb-4 text-lg font-bold" for="qr-content">Logo</div>
          <div class="flex w-full my-2" >
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-logo-none" class="visible" type="radio" value="none" v-model="options.qr_logo.type">
              <label for="qr-logo-none">No Logo</label>
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <input id="qr-logo-company" class="visible" type="radio"  value="company" v-model="options.qr_logo.type">
              <label for="qr-logo-company">Company Logo</label>
            </div>
            <div class="flex-initial w-1/6 mr-4" v-if="system.id !== 3 && system.networks[0].id!==7 && system.networks[0].id!==8">
              <input id="qr-logo-custom" class="visible" type="radio"  value="custom" v-model="options.qr_logo.type">
              <label for="qr-logo-custom">Custom Logo</label>
            </div>
            <div class="flex-initial w-1/6 mr-4" v-else-if="system.networks[0].id!==7 && system.networks[0].id!==8">
              <input id="qr-logo-fixed" class="visible" type="radio"  value="fixed" v-model="options.qr_logo.type">
              <label for="qr-logo-fixed">Custom Logo</label>
            </div>
          </div>
          <div class="flex w-full my-4" v-show="options.qr_logo.type==='custom'">
            <div class="w-full flex flex-col mr-8">
              <upload-dropzone @change="uploadCustomLogo($event)" accept="png" />
              <span v-if="customFile" class="p-2 bg-green text-white"> {{customFile.name}}</span>
            </div>
          </div>
        </div>
        <div class="border-bottom w-full pb-4 mt-6">
          <div class="my-2 pb-4 text-lg font-bold" for="qr-content">Style</div>
          <div class="flex w-full my-2" >
            <div class="flex-initial w-1/6 mr-4">
              <label class="form-check-label inline-block text-gray-800 h-full px-1" for="qr-style-square" :class="options.qr_style.type==='square'? 'border border-green' : ''">
                <standard-qr colour="#000" class="h-full"></standard-qr>
              </label>
              <input id="qr-style-square" class="invisible" type="radio" value="square" v-model="options.qr_style.type">
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <label class="form-check-label inline-block text-gray-800 h-full px-1" for="qr-style-round" :class="options.qr_style.type==='round'? 'border border-green' : ''">
                <round-qr colour="#000" class="h-full"></round-qr>
              </label>
              <input id="qr-style-round" class="invisible" type="radio" value="round" v-model="options.qr_style.type">
            </div>
            <div class="flex-initial w-1/6 mr-4">
              <label class="form-check-label inline-block text-gray-800 h-full px-1" for="qr-style-dot" :class="options.qr_style.type==='dot'? 'border border-green' : ''">
                <dot-qr colour="#000" class="h-full"></dot-qr>
              </label>
              <input id="qr-style-dot" class="invisible" type="radio" value="dot" v-model="options.qr_style.type">
            </div>
          </div>
        </div>
      </div>
      <div class="flex-wrap items-center text-center w-1/4 p-2">
        <div class="fixed px-8 ml-8 text-center">
          <img class="block w-3/4" :src="qrCodeUrl" v-if="previewImg!==''">
          <img class="block w-3/4" src="/img/qrcode.svg" width="300" height="300" v-else>
          <div class="block w-3/4 text-center mt-4 text-sm">Download a hi-res PNG file of your QR Code to be used on any of your printed material.</div>
          <div class="block w-3/4 text-center mt-4 flex">
            <button class="bg-white border border-primary text-sm p-2 mx-2" @click="saveQR">Save QR Code</button>
            <a :href="qrCodeUrl" class="bg-primary text-white text-sm p-2 mx-2 no-underline" download>Download QR Code</a>
          </div>
          <div class="block w-3/4 text-center mt-4 text-sm mt-2">*Statistic and tracking of these QR codes is not currently available.</div>
        </div>
      </div>
  </div>
</template>

<script>
import api, { v2Api } from '@/http'
import ColourPickerInput from '@/components/ColourPickerInput'
import UploadDropzone from '@/components/UploadDropzone'
import StandardQr from '@/components/digital-hub/qrcode-colour-icons/StandardQr.vue'
import RoundQr from '@/components/digital-hub/qrcode-colour-icons/RoundQr.vue'
import DotQr from '@/components/digital-hub/qrcode-colour-icons/DotQr.vue'
import { debounce, toNumber } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      options: {
        'qr_content': {
          'type': 'website',
          'website': '',
          'UTM_source': '',
          'UTM_campaign': '',
          'UTM_medium': '',
          'UTM_content': '',
          'UTM_term': '',
          'email': '',
          'emailSubject': '',
          'emailMsg': '',
          'phone': '',
          'smsMsg': '',
          'address': '',
          'lat': '',
          'lon': ''
        },
        'qr_colour': {
          'type': 'single',
          'colour1': '',
          'colour2': '',
          'colourBg': '#ffffff'
        },
        'qr_logo': {
          'type': 'none'
        },
        'qr_style': {
          'type': 'square'
        }
      },
      previewImg: '',
      customFile: null
    }
  },
  components: {
    ColourPickerInput,
    UploadDropzone,
    StandardQr,
    RoundQr,
    DotQr
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice,
      system: state => state.system
    }),
    qrCodeUrl: function () {
      return 'data:image/png;base64,' + this.previewImg
    },
    coords () {
      return {
        lat: toNumber(this.options.qr_content.lat),
        lng: toNumber(this.options.qr_content.lon)
      }
    }
  },
  watch: {
    options: {
      handler: debounce(function () {
        if (this.customFile) {
          this.uploadCustomLogo(null)
        } else {
          if (this.options.qr_content.type === 'location' && !this.options.qr_content.address) {
            var address = this.office.address_name_number + (this.office.address_line2 ? ' ' + this.office.address_line2 + ',' : '') +
            (this.office.address_line3 ? ' ' + this.office.address_line3 + ',' : '') + (!this.office.address_line2 && !this.office.address_line3 ? ',' : '') +
              (this.office.address_town ? this.office.address_town + ',' : '') + (this.office.address_postcode ? this.office.address_postcode : '')

            this.options.qr_content.address = address

            this.setPlace()
          }
          if (this.options.qr_content.type === 'email') {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
            if (!this.options.qr_content.email.match(validRegex)) {
              return
            }
          }
          this.updateQR()
        }
      }, 500),
      deep: true
    }
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    uploadCustomLogo (files) {
      if (files !== null) {
        this.customFile = files[0]
      } else if (!this.customFile) {
        return
      }
      // validate logo type
      let valid = false
      if (this.customFile.type === 'image/png' || this.customFile.type === 'image/jpeg') {
        valid = true
      }

      if (!valid) {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Upload Failed',
          info: `${this.customFile.name} is not a valid format, please use PNG or JPEG format image`
        })
        return
      }

      var data = new FormData()
      data.append('_method', 'PUT')
      data.append('file', this.customFile)
      data.append('office_id', this.office.id)
      this.buildFormData(data, this.options, 'options')
      api.post(`/qr-code/generator-create`, data).then((response) => {
        this.previewImg = response.data.img
      }, (errors) => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to create custom QR'
        })
      })
    },
    buildFormData (formData, data, parentKey) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
          this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
        })
      } else {
        const value = data == null ? '' : data

        formData.append(parentKey, value)
      }
    },
    updateQR: function () {
      api.put(`/qr-code/generator-create`, {
        options: this.options,
        office_id: this.office.id
      }).then(response => {
        this.previewImg = response.data.img
      }).catch(() => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to create custom QR'
        })
      })
    },
    saveQR: function () {
      api.post(`/qr-code/generator-save`, {
        options: this.options,
        office_id: this.office.id,
        image: this.previewImg
      }).then(response => {
        if (response.data.error === false) {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Saved',
            info: 'QR Saved'
          })
        } else {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Error',
            info: 'Failed to save custom QR'
          })
        }
      }).catch(() => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to save custom QR'
        })
      })
    },
    getAppearance: function () {
      v2Api.get(`/qr-code-appearance/${this.office.id}`).then(response => {
        this.options.qr_colour.colour1 = response.data.colour1
        this.options.qr_colour.colour2 = response.data.colour2
      }).catch(() => {
        console.log('Unable to get office style')
      })
    },
    setPlace: function (event) {
      api
        .get('/geocode', {
          params: {
            location: this.options.qr_content.address,
            country: 'GB'
          }
        })
        .then(response => {
          this.options.qr_content.lat = response.data.lat
          this.options.qr_content.lon = response.data.lon
        }, error => {
          console.log(error)
        })
    },
    setCoord: function (event) {
      this.options.qr_content.lat = event.latLng.lat()
      this.options.qr_content.lon = event.latLng.lng()
    }
  },
  created () {
    this.getAppearance()
  }
}
</script>

<style scoped>
button:focus {
  outline:0;
}

input[type="radio"] {
  display: inline-block;
}

input[type="radio"] + label {
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  line-height: 1rem;
}

input[type="radio"]:checked + label::before {
  content: "";
  border-width: 0px;
}

input[type="radio"]:checked + label::before {
  background: white;
}
input[type="radio"] + label::before {
  content: '';
  display: inline-block;
  width: 0px;
  height: 0px;
  margin-right: 5px;
  border: 0px;
  padding: 0px;
  background: white;
}
</style>
